module.exports = __webpack_public_path__ + "static/media/Rebecca (1).d8718902.jpg";